import {getPriceData} from './product-utils'

// Basket prices already include quantity and applied item promotions. Catalog
// promotions and master variants must not replace these authoritative amounts.
export const getCartPriceData = (product, basketQuantity = product.quantity) => {
    const quantity = basketQuantity > 0 ? basketQuantity : 1
    const weeeFee = (product.priceAdjustments || []).reduce(
        (total, adjustment) =>
            adjustment.promotionId === 'weeeFee' ? total + (adjustment.price || 0) : total,
        0,
    )
    const currentPrice =
        product.priceAfterItemDiscount != null
            ? product.priceAfterItemDiscount - weeeFee
            : product.price
    const unitPrice = currentPrice / quantity
    const priceData = getPriceData({
        ...product,
        price: unitPrice,
        type: undefined,
        hitType: undefined,
        productPromotions: [],
        tieredPrices: product.tieredPrices?.length
            ? product.tieredPrices
            : [{price: product.basePrice ?? product.price / quantity, quantity: 1}],
    })

    return {
        ...priceData,
        currentPrice,
        listPrice: priceData.listPrice * quantity,
        unitListPrice: priceData.listPrice,
        pricePerUnit: unitPrice,
        unitPrice,
    }
}
